const cs_CZ = {}

cs_CZ.strings = {
    browse:                    'procházejte',
    youCanOnlyUploadX:         {
        0: 'Můžete nahrát pouze %{smart_count} soubor',
        1: 'Můžete nahrát pouze %{smart_count} souborů'
    },
    youHaveToAtLeastSelectX:   {
        0: 'Musíte vybrat nejméně %{smart_count} soubor',
        1: 'Musíte vybrat nejméně %{smart_count} souborů'
    },
    exceedsSize:               'Maximální velikost souboru je',
    youCanOnlyUploadFileTypes: 'Můžete nahrát pouze:',
    dropPaste:                 'Přetáhněte soubory, nebo %{browse}',
    cancel:                    'Zrušit',
    complete:                  'Hotovo',
    back:                      'Zpět',
    uploading:                 'Nahrávám',
    addingMoreFiles:           'Nahrát více souborů',
    addMoreFiles:              'Nahrát více souborů',
    closeModal:                'Zavřít okno',
    upload:                    'Nahrát',
    name:                      'Jméno',

}

export default cs_CZ;



// WEBPACK FOOTER //
// ./src/service/uppy/cs_CZ.js